import React from 'react';
interface AmbientThreadsProps {
  variant?: 'hero' | 'soft' | 'minimal';
  className?: string;
}
/**
 * Subtle orange conversation-thread background SVGs.
 * Designed to feel like thought currents drifting across a section.
 */
const AmbientThreads: React.FC<AmbientThreadsProps> = ({
  variant = 'soft',
  className = ''
}) => {
  if (variant === 'minimal') {
    return <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-id="element-22">
        <svg className="thread-drift absolute -right-20 top-20 w-[600px] h-[600px] opacity-[0.08]" viewBox="0 0 600 600" fill="none" data-id="element-23">
          <path d="M50 300 Q 200 100, 400 250 T 700 300" stroke="#E87B5C" strokeWidth="1.5" strokeLinecap="round" data-id="element-24" />
          <path d="M30 360 Q 180 180, 380 320 T 680 370" stroke="#E87B5C" strokeWidth="1" strokeLinecap="round" data-id="element-25" />
        </svg>
      </div>;
  }
  if (variant === 'hero') {
    return <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-id="element-26">
        {/* Top-right thread cluster */}
        <svg className="thread-drift absolute -right-32 -top-20 w-[900px] h-[900px] opacity-[0.1]" viewBox="0 0 900 900" fill="none" data-id="element-27">
          <path d="M100 400 Q 300 150, 550 300 T 900 350" stroke="#E87B5C" strokeWidth="1.5" strokeLinecap="round" data-id="element-28" />
          <path d="M80 460 Q 280 220, 530 370 T 880 420" stroke="#E87B5C" strokeWidth="1" strokeLinecap="round" data-id="element-29" />
          <path d="M120 340 Q 320 90, 570 240 T 920 290" stroke="#E87B5C" strokeWidth="0.8" strokeLinecap="round" data-id="element-30" />
        </svg>

        {/* Bottom-left thread cluster */}
        <svg className="thread-drift-alt absolute -left-40 bottom-0 w-[800px] h-[800px] opacity-[0.08]" viewBox="0 0 800 800" fill="none" data-id="element-31">
          <path d="M50 500 Q 200 250, 450 400 T 800 450" stroke="#E87B5C" strokeWidth="1.5" strokeLinecap="round" data-id="element-32" />
          <path d="M30 560 Q 180 320, 430 470 T 780 520" stroke="#E87B5C" strokeWidth="1" strokeLinecap="round" data-id="element-33" />
        </svg>

        {/* Soft warm glow */}
        <div className="absolute top-1/4 right-1/4 w-[500px] h-[500px] rounded-full opacity-[0.18] blur-3xl" style={{
        backgroundColor: 'var(--peach)'
      }} data-id="element-34" />
      </div>;
  }
  // soft (default)
  return <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-id="element-35">
      <svg className="thread-drift absolute -right-24 top-10 w-[700px] h-[700px] opacity-[0.07]" viewBox="0 0 700 700" fill="none" data-id="element-36">
        <path d="M80 350 Q 250 120, 470 270 T 750 320" stroke="#E87B5C" strokeWidth="1.3" strokeLinecap="round" data-id="element-37" />
        <path d="M60 410 Q 230 190, 450 340 T 730 390" stroke="#E87B5C" strokeWidth="0.9" strokeLinecap="round" data-id="element-38" />
      </svg>
      <svg className="thread-drift-alt absolute -left-20 bottom-10 w-[600px] h-[600px] opacity-[0.06]" viewBox="0 0 600 600" fill="none" data-id="element-39">
        <path d="M40 380 Q 160 180, 350 320 T 620 370" stroke="#E87B5C" strokeWidth="1.2" strokeLinecap="round" data-id="element-40" />
      </svg>
    </div>;
};
export default AmbientThreads;